import { Outlet } from 'react-router-dom';
import { paths } from 'core/routing/paths';
import { AppShell, BrandLink, ShellMain } from 'layout/AppShell';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';

export function AuthLayout() {
  return (
    <AppShell className="auth-shell" compactFooter>
      <header className="site-header">
        <div className="shell-container header-inner">
          <BrandLink to={paths.welcome} compact />
          <div className="header-end">
            <LanguageSwitcher />
          </div>
        </div>
      </header>
      <ShellMain className="auth-main">
        <div className="shell-container auth-container">
          <Outlet />
        </div>
      </ShellMain>
    </AppShell>
  );
}
